import React from 'react';
import { InputContainer } from '../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';

export const TemplatesBasicInfoComponent = ({ onInnerBasicFormChange, selectedTemplatedGroups,accountTypesListLoading,accountListLoading, accountsList, accountTypesList, Account, accountType, PolicyOwnerType, communities, Programs }: any) => {

    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Active"
                        name="IsActive"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedTemplatedGroups?.IsActive}
                    />

                     <InputContainer
                        label="Level"
                        labelField="Text"
                        list={PolicyOwnerType}
                        isDisabled={selectedTemplatedGroups?.Id && selectedTemplatedGroups?.OwnerLevelId}
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerLevelId'
                            );
                        }}
                        optionName='Choose Level'
                        type="select"
                        value={selectedTemplatedGroups?.OwnerLevelId}
                        valueField="Value"
                    />
                    <InputContainer
                        label="Account Type"
                        labelField="Name"
                        isLoading={accountTypesListLoading}
                        list={accountTypesList}
                        isDisabled={selectedTemplatedGroups?.Id && selectedTemplatedGroups?.OwnerTypeId}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerTypeId',
                            );
                        }}
                        optionName='Choose Account Type'
                        type="select"
                        value={selectedTemplatedGroups?.OwnerTypeId}
                        valueField="Id"
                    />
                    <InputContainer
                        label="Account Name"
                        labelField="Name"
                        isLoading={accountListLoading}
                        list={accountsList}
                        isDisabled={selectedTemplatedGroups?.Id && selectedTemplatedGroups?.OwnerAccountId}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'OwnerAccountId',
                            );
                        }}
                        optionName='Choose Account Name'
                        type="select"
                        value={selectedTemplatedGroups?.OwnerAccountId}
                        valueField="Id"
                    />



                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedTemplatedGroups?.Name}
                    />

                    <InputContainer
                        label="Remarks"
                        name="Remarks"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Remarks'

                            )
                        }}
                        type="text"
                        value={selectedTemplatedGroups?.Remarks}
                    />

                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedTemplatedGroups?.Description}
                    />

                    <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedTemplatedGroups?.StartDateUtc}
                    />

                    <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedTemplatedGroups?.EndDateUtc}
                    />




                    <InputContainer
                        label="Display Order"
                        name="DisplayOrder"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'DisplayOrder'

                            )
                        }}
                        type="number"
                        value={selectedTemplatedGroups?.DisplayOrder}
                    />


                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default TemplatesBasicInfoComponent;
